module.exports = __webpack_public_path__ + "static/polarpumpen-web1@2x-min-7f612ca7a23705c81d5ae3a41837c8e5.jpg";